import React, { Fragment, useState } from 'react';
import { Collapse, Nav, NavItem, Navbar, NavbarToggler } from 'reactstrap';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { Logo } from '../../Assets';
import { Link } from 'react-router-dom';
import { EmployeeRoutes, ManagerRoutes } from './Manager';
import { Button } from '../../Atoms';

import './sidebar.scss';
import { setupHttpConfig } from '../../utils/http';
import { logout } from '../../redux/actions/AuthenticationAction';
import { connect } from 'react-redux';

const Sidebar = ({ userInfo, logout }) => {
  const [isOpen, setOpen] = useState(false);
  const history = useHistory();
  const toggle = () => {
    setOpen(!isOpen);
  };

  const isActive = (path) => {
    const {
      location: { pathname },
    } = history;
    return `/${path}` === pathname;
  };

  const handleLogout = () => {
    localStorage.clear();
    setupHttpConfig();
    logout();
    setTimeout(() => {
      history.push('/login');
    });
  };

  const {
    company: { google_data_studio_url } = {},
    google_data_studio_url: employee_data,
  } = userInfo || {};
  const studio_url = employee_data || google_data_studio_url;
  const { role } = userInfo;
  const routes = role === 'employee' ? EmployeeRoutes : ManagerRoutes;

  const ClevelRoutes = routes.filter((r) => !r.hide || studio_url);
  return (
    <div className="sidebar-wrapper">
      <div className="logo-wrapper">
        <div className="logo-image">
          <Logo width={173} height={34} />
        </div>
        <Navbar color="none" light expand="md" className="custom-navbar">
          <div>
            <NavbarToggler onClick={toggle} />
          </div>
          <Collapse isOpen={isOpen} navbar>
            <Nav className="" navbar>
              {ClevelRoutes.map(
                (
                  { divider, active, to, icon: Icon, title, extraClass = '' },
                  index
                ) => (
                  <Fragment key={index}>
                    {divider ? (
                      <hr className="w-75 px-2" />
                    ) : (
                      <NavItem
                        className={classNames({
                          active: isActive(active),
                          [extraClass]: extraClass,
                        })}
                      >
                        <Link to={to}>
                          <Icon />
                          {title}
                        </Link>
                      </NavItem>
                    )}
                  </Fragment>
                )
              )}
              <NavItem className="logout-wrapper">
                <Button
                  style={{ width: 204 }}
                  size="md"
                  color="white"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(logout());
  },
});

export default connect(null, mapDispatchToProps)(Sidebar);
